import util from '@/libs/util'

const post = util.ajax.post

export const loginUrls = [
  // 登录
  '/doLogin',
  // 退出登录
  '/loginOut',
  // 是否登录
  '/isLogin'
]

export const loginArr = {}

loginArr.doLogin = function (params) {
  return post('/auth/login', params)
}
loginArr.loginOut = function (params) {
  return post('/loginOut', params)
}
loginArr.isLogin = function (params) {
  return post('/isLogin', params)
}



// WEBPACK FOOTER //
// ./src/api/gip/login/loginUrl.js